/**
 * Created on 2017/2/19.
 */
define('controllers/myaccount/balance/account-balance.ctrl',['app', 'mainCons', 'viewer'], function (app, mainCons, imgViewer) {
    app.controller('AccountBalanceCtrl', ['$q', '$scope', '$rootScope', '$state', '$stateParams', '$filter', 'OpenOther', 'OpenApp', 'OpenTrade', 'AppPromote', 'InAppNew', 'OpenUp', 'auiDialog', 'ngDialog', 'UserInfo', 'UserInfoPreload', 'auiBalanceService', 'modBussService', 'invoiceService', 'regionService', 'formValidateService', 'auiUpload', 'auiAgreementHelper', 'auiTeamAccountService', 'bankSelectService',
        function ($q, $scope, $rootScope, $state, $stateParams, $filter, OpenOther, OpenApp, OpenTrade, AppPromote, InAppNew, OpenUp, auiDialog, ngDialog, UserInfo, UserInfoPreload, auiBalanceService, modBussService, invoiceService, regionService, formValidateService, auiUpload, auiAgreementHelper, auiTeamAccountService, bankSelectService) {
            /* 1. 局部变量声明 */

            /* 2. $scope变量声明 */
            /* 3. $scope函数挂载 */
            $scope.payOrder = payOrder;
            $scope.oldpayOrder = oldpayOrder;
            $scope.confirmPay = confirmPay;
            $scope.cancelOrder = cancelOrder;
            $scope.refundOrder = refundOrder;
            $scope.refundDetail = refundDetail;
            $scope.exportContract = exportContract;
            $scope.queryList = queryList;
            $scope.goInvoice = goInvoice;
            $scope.changeTabType = changeTabType;
            $scope.applyBilling = applyBilling;
            $scope.reapplyBilling = reapplyBilling;
            $scope.transferFund = transferFund;
            $scope.getGiftBalanceDetails = getGiftBalanceDetails;
            $scope.queryOrderDetail = queryOrderDetail;
            $scope.transferShow = transferShow;
            $scope.appTransfer = appTransfer;
            $scope.transferDetail = transferDetail;
            $scope.appTransferDetail = appTransferDetail;
            $scope.getDeveloperBaseInfo = getDeveloperBaseInfo;

            $rootScope.checkState($state).then(function () {
                init();
            });
            //获取订单ID
            var signParty = $scope.signParty = [$stateParams.signParty * 1];

            var Model = $scope.Model = {};

            var currentType = $scope.currentType = mainCons.balanceConstant.currentTypes[$scope.signParty[0]];

            var currencyUnit = $scope.currencyUnit = mainCons.balanceConstant.currentUnits[$scope.signParty[0]];
            $scope.promoteAccountName = mainCons.balanceConstant.accountnTypes.promoteAccount[$scope.signParty[0]];

            $scope.ppsAccountName = mainCons.balanceConstant.accountnTypes.ppsAccount[$scope.signParty[0]];

            var rate = mainCons.balanceConstant.currenRate[$scope.currentType];

            Model.isTeamId = AUI.HDGWCall.getUserInfoValue('teamid');
            
            Model.grayUserCuting = false;

            Model.isShowFund = false;

            Model.isSignAgree = false;

            Model.queryParamType = 0;

            Model.isContractTypeConsumptionRebate = false;
            Model.inappType = 22;
            Model.innewappType = 51;
            Model.tongyongType = 999;
            Model.userType = UserInfoPreload.userType;
            Model.wareId2Name = ($scope.signParty[0] == 2 ? mainCons.balanceConstant.yxqwareType : mainCons.balanceConstant.purchaseTypeTHPType);
            var wares = mainCons.balanceConstant.ware;
            if ($scope.signParty[0] == 2) {
                wares = mainCons.balanceConstant.yxqware;
            }
            if (Model.userType == 1) {
                wares = mainCons.balanceConstant.personalware;
            }
            var contractTypes = Model.userType == 1 ? mainCons.balanceConstant.contractTypeTHP : mainCons.balanceConstant.contractTypeTH;
            if ($scope.signParty[0] == 1) {
                //对5和12做特殊处理  大陆内和大陆外的都有的  做区分
                var contractTypesTemp = AUI.BaseJSUtil.deleteObjFromArr(mainCons.balanceConstant.contractTypeTH, 'id', '5');
                contractTypesTemp = AUI.BaseJSUtil.deleteObjFromArr(contractTypesTemp, 'id', '12');
                contractTypes = contractTypesTemp.concat(mainCons.balanceConstant.contractTypeTHExtend);
                contractTypes.sort(AUI.BaseJSUtil.arrObjCompare('id', true));//排个序
                contractTypes.sort(AUI.BaseJSUtil.arrObjCompare('enIndex', true));//排个序
            }
            Model.order = {
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        totalCount: 0,
                        noItems: "No oders",
                        pagesLength: 10,// 显示的页码数量,
                        onChange: queryListSplitPage
                    },
                    tableHeader: {
                        orderId: {name: ''},
                        purchaseType: [],
                        contractType: [],
                        createTime: {
                            sortType: 1,//1:按顺序 ， 2：按时间区间
                            sortOrder: 1,//1:按时间新到旧  2：按时间旧到新
                            fromTime: new Date(),
                            toTime: new Date()
                        },
                        dealTime: {
                            sortOrder: 2//0:按新到旧  1：按旧到新
                        },
                        wareId: '',
                        money: {
                            sortOrder: 2//0:按高到低排序  1：按低到高排序
                        },
                        financialType: '',
                        receiptStatus: '',
                        // status: ($stateParams.signParty != 0 && $stateParams.signParty !=1) ?['2']:''
                        status: ''
                    }
                },
                tableHeader: {
                    orderId: {
                        id: "orderId",
                        name: "订单编号",
                        filterMethod: querySearchList,
                        queryMethod: queryListByCondition
                    },
                    purchaseType: {
                        id: "purchaseType",
                        name: "来源",
                        data: Model.userType == 1 ? mainCons.balanceConstant.purchaseTypeTHP : mainCons.balanceConstant.purchaseTypeTH,
                        queryMethod: queryListByCondition
                    },
                    contractType: {
                        id: "contractType",
                        name: "订单类型",
                        data: contractTypes,
                        queryMethod: queryListByCondition
                    },
                    createTime: {
                        id: "createTime",
                        name: "创建时间",
                        queryMethod: queryByCreateTime
                    },
                    dealTime: {
                        id: "dealTime",
                        name: "成交时间",
                        choices: [{id: '0', name: '由新到旧排序'}, {id: '1', name: '由旧到新排序'}],
                        queryMethod: queryByDealTime
                    },
                    wareId: {
                        id: "wareId",
                        name: "充值用途",
                        width: 240,
                        data: wares,
                        queryMethod: queryListByCondition
                    },
                    money: {
                        id: "money",
                        name: "金额",
                        choices: [{id: '0', name: '由高到低排序'}, {id: '1', name: '由低到高排序'}],
                        queryMethod: queryByMoney
                    },
                    financialType: {
                        id: "financialType",
                        name: "交易类型",
                        data: Model.userType == 1 ? mainCons.balanceConstant.financialTypeTHP : mainCons.balanceConstant.financialTypeTH,
                        queryMethod: queryListByCondition
                    },
                    receiptStatus: {
                        id: "receiptStatus",
                        name: "发票状态",
                        data: Model.userType == 1 ? mainCons.balanceConstant.receiptStatusTHP : mainCons.balanceConstant.receiptStatusTH,
                        queryMethod: queryListByCondition
                    },
                    status: {
                        id: "status",
                        name: "状态",
                        data: $scope.signParty[0] == 2 ? mainCons.balanceConstant.orderStatusTHYX : mainCons.balanceConstant.orderStatusTH,
                        queryMethod: queryListByCondition
                    }

                }
            };
            Model.constant = {
                orderStatus: mainCons.balanceConstant.orderStatus,
                purchaseType: mainCons.balanceConstant.purchaseType,
                contractType: mainCons.balanceConstant.contractType,
                contractTypes: mainCons.balanceConstant.contractTypes,
                financialType: mainCons.balanceConstant.financialType,
                receiptStatus: mainCons.balanceConstant.receiptStatus
            };

            Model.downLoadAgreement = function () {
                auiAgreementHelper.viewAndDownloadAgreements([1010]);
            };

            function querySearchList() {
                var defer = $q.defer();
                var getOrderListRequest = {
                    signPartys: ($stateParams.signParty == 1 ? [1, 4] : signParty),
                    fromRecCount: 1,
                    searchTxt: Model.order.query.tableHeader.orderId.name
                };
                OpenTrade.getOrderList({req: getOrderListRequest}, true).then(function (data) {
                    var result = [];
                    var orderList = data && data.orderList;
                    if (orderList && orderList.length > 0) {
                        for (var i in orderList) {
                            result.push(orderList[i].orderId);
                        }
                    }
                    defer.resolve(AUI.BaseJSUtil.unique(result));
                });
                return defer.promise;
            }

            function getDeveloperBaseInfo() {
                OpenUp.getDeveloperBaseInfo({baseReq: {}}).then(function (loginUserInfo) {
                    if (loginUserInfo && loginUserInfo.developerInfo) {
                        developerInfo = loginUserInfo.developerInfo;
                    }
                })
            }

            function queryByCreateTime() {
                Model.queryParamType = 1;
                queryListByCondition('createTime');
            }

            function queryByDealTime() {
                Model.queryParamType = 2;
                queryListByCondition('dealTime');
            }

            function queryByMoney() {
                Model.queryParamType = 3;
                queryListByCondition('money');
            }

            function queryListByCondition(qType) {
                //设置分页为第一页
                Model.order.query.pagination.currentPage = 1;
                queryList(qType);
            }

            function queryListSplitPage() {
                if (Model.queryParamType == 1) {
                    queryList('createTime');
                } else if (Model.queryParamType == 2) {
                    queryList('dealTime');
                } else if (Model.queryParamType == 3) {
                    queryList('money');
                } else {
                    queryList();
                }
            }

            function queryList(qType) {
                if (!Model.isSignAgree) {
                    return;
                }
                var defer = $q.defer();
                //带分页事件的查询
                var getOrderListRequest = {
                    fromRecCount: 1 + (Model.order.query.pagination.currentPage - 1) * Model.order.query.pagination.itemsPerPage,
                    maxReqCount: Model.order.query.pagination.itemsPerPage,
                    sortType: 0,
                    signPartys: ($stateParams.signParty == 1 ? [1, 4] : signParty),
                    sortField: "createTime",
                    financialType: [0, 1]
                };

                Model.order.query.tableHeader.purchaseType != "" ? getOrderListRequest.purchaseType = Model.order.query.tableHeader.purchaseType : "";
                Model.order.query.tableHeader.contractType != "" ? getOrderListRequest.contractType = Model.order.query.tableHeader.contractType : "";
                Model.order.query.tableHeader.wareId != "" ? getOrderListRequest.wareId = Model.order.query.tableHeader.wareId : "";
                Model.order.query.tableHeader.status != "" ? getOrderListRequest.status = Model.order.query.tableHeader.status : "";
                Model.order.query.tableHeader.orderId != "" ? getOrderListRequest.searchTxt = Model.order.query.tableHeader.orderId.name : "";
                Model.order.query.tableHeader.financialType != "" ? getOrderListRequest.financialType = Model.order.query.tableHeader.financialType : "";
                Model.order.query.tableHeader.receiptStatus != "" ? getOrderListRequest.receiptStatus = Model.order.query.tableHeader.receiptStatus : "";
                if (Model.order.query.tableHeader.status.indexOf('17') > -1 && Model.order.query.tableHeader.status.indexOf('18') == -1) {
                    Model.order.query.tableHeader.status.push('18')
                    getOrderListRequest.status = Model.order.query.tableHeader.status
                }
                if (Model.order.query.tableHeader.status.indexOf('17') == -1 && Model.order.query.tableHeader.status.indexOf('18') > -1) {
                    var index = Model.order.query.tableHeader.status.indexOf('18')
                    getOrderListRequest.status = Model.order.query.tableHeader.status.splice(index, 1)
                }
                if (qType) {
                    getOrderListRequest.sortField = qType;

                    if (qType === 'createTime') {
                        if (Model.order.query.tableHeader.createTime.sortType == 1) {
                            getOrderListRequest.sortType = Model.order.query.tableHeader.createTime.sortOrder == 0 ? 1 : 0;
                        }
                        //清空金额和成交时间的排序
                        Model.order.query.tableHeader.money = "-1";
                        Model.order.query.tableHeader.dealTime = '-1';
                    } else if (qType === 'dealTime') {
                        getOrderListRequest.sortType = Model.order.query.tableHeader.dealTime;
                        //清空金额和创建时间的排序
                        Model.order.query.tableHeader.money = "-1";
                    } else if (qType === 'money') {
                        getOrderListRequest.sortType = Model.order.query.tableHeader.money;
                        //清空成交和创建时间的排序
                        Model.order.query.tableHeader.dealTime = '-1';
                    }
                }

                //判断类型是否为“消费返利”，如果是，则展示“appid”和“应用名称”
                if (Model.order.query.tableHeader.contractType && Model.order.query.tableHeader.contractType.indexOf('6') > -1) {
                    Model.isContractTypeConsumptionRebate = true;
                } else {
                    Model.isContractTypeConsumptionRebate = false;
                }

                //如果有时间段，则支持时间段查询
                if (Model.order.query.tableHeader.createTime.sortType == 2) {
                    getOrderListRequest.fromTime = $filter('date')(Model.order.query.tableHeader.createTime.fromTime, 'yyyy-MM-dd 00:00:00');
                    getOrderListRequest.toTime = $filter('date')(Model.order.query.tableHeader.createTime.toTime, 'yyyy-MM-dd 23:59:59');
                    getOrderListRequest.timeType = 0;
                }

                OpenTrade.getOrderList({req: getOrderListRequest}).then(function (data) {

                    Model.order.orderList = data.orderList;
                    if (Model.order.orderList.length > 0) {
                        angular.forEach(Model.order.orderList, function (order) {
                            if (order.dealTime) {
                                if ($filter('date')(new Date(), 'yyyy-MM-dd') > $filter('date')(AUI.DateUtil.calDaysLater(AUI.DateUtil.stringToDate(order.dealTime), 182), 'yyyy-MM-dd')) {
                                    order.isCanApply = false;
                                } else {
                                    order.isCanApply = true;
                                }
                            }
                        })
                    }
                    Model.order.query.pagination.totalCount = data.totalCount;
                    Model.order.payInfo = data.payInfo;
                    defer.resolve(data);
                    if (Model.order.orderList.length > 0 && Model.order.query.tableHeader.contractType.indexOf('6') > -1) {
                        getAppName();
                    }
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function getAppName() {
                var contractTypeAppIdList = [];
                var appName = {};
                Model.order.orderList.forEach(function (item) {
                    if (item.appId) {
                        contractTypeAppIdList.push(item.appId)
                    }
                });
                if (contractTypeAppIdList.length > 0) {
                    OpenApp.getAppBriefList({
                        req: {
                            prodIDList: AUI.BaseJSUtil.unique(contractTypeAppIdList),
                            maxReqCount: 5000,
                            lang: 'zh_cn'
                        }
                    }).then(function (resp) {
                        if (resp && resp.resultCode == 0 && resp.appBriefList.length > 0) {
                            resp.appBriefList.forEach(function (item) {
                                appName[item.prodID] = item.prodName;
                            });
                            putAppName2orderList(appName);
                        }
                    })

                }
            }

            function putAppName2orderList(appName) {
                Model.order.orderList.forEach(function (item) {
                    if (item.appId) {
                        item.appName = appName[item.appId];
                    }
                });
            }

            function getBalance() {
                var defer = $q.defer();
                var queryBalanceReq = {
                    version: '1.0',
                    signPartys: ($stateParams.signParty == 1 ? [1, 4] : signParty),
                    traceUniqueID: auiBalanceService.getTraceUniqueID()
                };
                //获取金额
                OpenTrade.getBalance({req: queryBalanceReq}, true).then(function (data) {
                    //总额（通用+应用市场+文件夹）
                    //可用余额
                    Model.totalValidBalance = data.totalValidBalance;
                    Model.totalBalance = data.totalBalance;
                    //通用总金额（现金）
                    Model.currencyBalance = 0;
                    //通用有效总金额（现金）
                    Model.currencyValidBalance = 0;
                    //应用市场总金额(现金+资源置换+赠送)
                    Model.inappBalanceTotal = 0;
                    //应用市场有效总金额（现金）
                    Model.inappValidBalance = 0;

                    //云文件夹总金额(现金+资源置换+赠送)
                    Model.inappNewBalanceTotal = 0;
                    //云文件夹有效总金额（现金）
                    Model.inappNewValidBalance = 0;

                    //应用市场现金金额
                    Model.inappBalanceCash = 0;
                    //云文件夹现金金额
                    Model.inappNewBalanceCash = 0;

                    //应用市场置换金额
                    Model.inappBalanceZhihuan = 0;
                    //云文件夹置换金额
                    Model.inappNewBalanceZhihuan = 0;

                    //应用市场赠送金额
                    Model.inappBalanceGift = 0;

                    //应用市场有效赠送金额
                    Model.inappValidBalanceGift = 0;
                    //云文件夹赠送金额
                    Model.inappNewBalanceGift = 0;

                    //云文件夹有效赠送金额
                    Model.inappNewValidBalanceGift = 0;

                    //应用市场返利金额
                    Model.inappBalanceRebase = 0;
                    //云文件夹返利金额
                    Model.inappNewBalanceRebase = 0;

                    if (Model.totalBalance > 0 || (data.accountInfos && data.accountInfos.length > 0)) {
                        Model.isShowFund = true;
                    }
                    if (data.accountInfos && data.accountInfos.length > 0) {
                        angular.forEach(data.accountInfos, function (account) {
                            //现金
                            if (account.accountType == 1) {
                                angular.forEach(account.balances, function (balance) {
                                    //通用
                                    if (balance.serviceItem == Model.tongyongType) {
                                        Model.currencyBalance += balance.balance;
                                        Model.currencyValidBalance = balance.transferBalance;
                                    }
                                    //应用市场
                                    else if (balance.serviceItem == Model.inappType) {
                                        Model.inappBalanceTotal += balance.balance;
                                        Model.inappBalanceCash = balance.balance;
                                        Model.inappValidBalance = balance.transferBalance;
                                    }
                                    //云文件夹
                                    else if (balance.serviceItem == Model.innewappType) {
                                        Model.inappNewBalanceTotal += balance.balance;
                                        Model.inappNewBalanceCash = balance.balance;
                                        Model.inappNewValidBalance = balance.transferBalance;
                                    }

                                });
                            }
                            //资源置换
                            else if (account.accountType == 2) {
                                angular.forEach(account.balances, function (balance) {
                                    //应用市场
                                    if (balance.serviceItem == Model.inappType) {
                                        Model.inappBalanceTotal += balance.balance;
                                        Model.inappBalanceZhihuan = balance.balance;
                                    }
                                    //云文件夹
                                    else if (balance.serviceItem == Model.innewappType) {
                                        Model.inappNewBalanceTotal += balance.balance;
                                        Model.inappNewBalanceZhihuan = balance.balance;
                                    }
                                });
                            }
                            //纯赠送
                            else if (account.accountType == 3 || account.accountType == 4) {
                                angular.forEach(account.balances, function (balance) {
                                    //应用市场
                                    if (balance.serviceItem == Model.inappType) {
                                        Model.inappBalanceTotal += balance.balance;
                                        Model.inappBalanceGift += balance.balance;
                                        Model.inappValidBalanceGift += balance.transferBalance;
                                    }
                                    //云文件夹
                                    else if (balance.serviceItem == Model.innewappType) {
                                        Model.inappNewBalanceTotal += balance.balance;
                                        Model.inappNewBalanceGift += balance.balance;
                                        Model.inappNewValidBalanceGift += balance.transferBalance;
                                    }
                                });
                            }
                        });
                    }
                    defer.resolve();
                });
                return defer.promise;

            }

            //获取
            function getGiftBalanceDetails(serviceItem) {
                $scope.close = function () {
                    ngd.close();
                };
                $scope.serviceItem = serviceItem;
                var ngd = ngDialog.open({
                    template: 'pages/myaccount/balance/balance.giftbalance.details.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    scope: $scope,
                    controller: 'GiftBalanceDetailCtrl'
                });

            }

            function transferFund(money, serviceItem) {
                var ngd = ngDialog.open({
                    template: 'pages/myaccount/balance/balance.transfer.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scope) {
                        var Model = $scope.Model = {};

                        Model.currentType = currentType;
                        Model.currencyUnit = currencyUnit;
                        Model.signParty = signParty[0];
                        var accountType = 1;
                        var unit = '元';
                        if (Model.signParty == 0 || Model.signParty == 1) {
                            Model.transferFundTypeList = [
                                {key: 999, value: "通用基金"},
                                {key: 51, value: "鲸鸿动能广告投放基金"},
                                {key: 22, value: "应用市场推广基金"}
                            ];
                            if (serviceItem == 999) {
                                Model.transferFundTypeList.splice(0, 1);
                            } else if (serviceItem == 51) {
                                Model.transferFundTypeList.splice(1, 1);
                            } else if (serviceItem == 22) {
                                Model.transferFundTypeList.splice(2, 1);
                            }
                            accountType = 1;
                            unit = '元';
                        } else if (Model.signParty == 2) {
                            Model.transferFundTypeList = [
                                {key: 51, value: "鲸鸿动能耀星流量券账户"},
                                {key: 22, value: "应用市场推广耀星流量券账户"}
                            ];
                            if (serviceItem == 51) {
                                Model.transferFundTypeList.splice(0, 1);
                            } else if (serviceItem == 22) {
                                Model.transferFundTypeList.splice(1, 1);
                            }
                            accountType = 3;
                            unit = '流量';
                        }


                        Model.typeSelected = Model.transferFundTypeList[0];

                        Model.moneyTotal = money;
                        //转账金额
                        Model.amount;

                        Model.isAmountValid = true;

                        $scope.close = function () {
                            ngd.close();
                        };
                        $scope.amountKeyup = function () {
                            Model.isAmountValid = auiBalanceService.validateTransferBalance(Model.amount, money, rate);
                        };

                        $scope.transferBalance = function () {
                            if (!Model.amount || !Model.isAmountValid) {
                                Model.isAmountValid = false;
                                return;
                            }

                            var transferInfo = {
                                messageID: auiBalanceService.getMessageId(),
                                accountType: accountType,
                                srcServiceItem: serviceItem,
                                signParty: signParty[0],
                                destServiceItem: Model.typeSelected.key,
                                amount: AUI.BaseJSUtil.accMul(Model.amount, rate)
                            };
                            var transferReq = {
                                version: "1.0",
                                traceUniqueID: auiBalanceService.getTraceUniqueID(),
                                transferInfo: transferInfo
                            };

                            OpenTrade.transfer({req: transferReq}).then(function () {
                                ngd.close();
                                auiDialog.success("划转给" + getServiceName(Model.typeSelected.key) + Model.amount + unit, function () {
                                    getBalance();
                                });
                            });

                        };

                        function getServiceName(srcServiceItem) {
                            var serviceName = "";
                            angular.forEach(Model.transferFundTypeList, function (transferFundType) {
                                if (transferFundType.key == srcServiceItem) {
                                    serviceName = transferFundType.value;
                                }
                            });
                            return serviceName;
                        }

                    }]
                });
            }

            function oldpayOrder(order) {
                //老的支付流程
                var developInfo = {};
                developInfo.orderInfo = order;
                developInfo.payInfo = Model.order.payInfo;
                //打开支付页面
                auiBalanceService.openPayPage(developInfo);
            }

            //跳转到支付页面
            function payOrder(order) {
                //新的国内支付流程默认开启
                var orderInfo = {};
                orderInfo.orderId = order.orderId;
                orderInfo.returnUrl = location.href.split('?')[0];
                //打开支付页面 调后台接口OpenTrade.Server4User
                OpenTrade.getCashierUrl({req: orderInfo}).then(function (res) {
                    if (res && res.cashierUrl && AUI.BaseJSUtil.contains(AUI.auiConfig().onlineWhiteOriginUrl, res.cashierUrl.split('/').splice(0, 3).join('/'))) {
                        AUI.BaseJSUtil.redirectUrlByBlank(res.cashierUrl);
                        auiBalanceService.openChinaDialog();
                    } else {
                        oldpayOrder(order);
                    }
                });

            }

            //跳转确认支付页面
            function confirmPay(orderId, money, signParty) {
                auiBalanceService.uploadCertificate(orderId, money, signParty, '', init, imgViewer);
            }

            //跳转到发票页面
            function goInvoice() {
                $rootScope.isBlance = true;
                $state.go('mysetting.payService.modInvoice', {}, {reload: true});
            }

            //取消订单
            function cancelOrder(orderId) {
                var defer = $q.defer();
                auiDialog.confirm('确认要取消订单吗？', function () {
                    OpenTrade.cancelOrder({req: {orderId: orderId}}).then(function (res) {
                        if (res && res.retCode == 0) {
                            auiDialog.success("取消订单成功。", function () {
                                //刷新页面
                                defer.resolve();
                                init();
                            });
                        }
                    }).catch(function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //退款
            function refundOrder(order) {
                //打开aui申请退款页面
                // auiBalanceService.refundOrder(order);
                var ngdia = ngDialog.open({

                    template: 'pages/myaccount/balance/order.refund.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', 'tenantsService', function ($scope, tenantsService) {
                        var Model = $scope.Model = {};
                        Model.order = order;
                        Model.refundInfo = {};
                        Model.realName = order.developerName || developerInfo.realName;
                        Model.pageOne = true;
                        Model.signParty = order.signParty;
                        Model.isHasCode = true;
                        Model.isHasBank = false;
                        Model.isHasKong = true;
                        Model.isHasCountryEn = false;
                        Model.isSucrefund = isSucrefundJudge(Model.order.status, Model.order.dealTime);

                        Model.refundReasons = mainCons.balanceConstant.refundReasons;
                        Model.symbol = mainCons.balanceConstant.currencyTypes.symbol[Model.order.currency]
                        Model.threshold = Model.symbol + mainCons.balanceConstant.currencyTypes.threshold[Model.order.currency];
                        Model.downAgreementReferTemplate = systemParaConf.agreementReferTemplate;
                        Model.refundTips = mainCons.balanceConstant.refundContactInfo;
                        Model.incomingIinfotips = '退票接收地址：中国-江苏省-南京-雨花台区华为路北侧华为二期<br>' +
                            '退票收件人：' + Model.refundTips.person + '<br>' + '退票收件人联系电话：' + Model.refundTips.phone;
                        Model.countrys = [
                            {key: 'CN', value: '中国'}
                        ]
                        $scope.changeCountry = changeCountry;
                        $scope.changeCountryEn = changeCountryEn;
                        $scope.changeBankNameEn = changeBankNameEn;
                        $scope.showSearchDlgEN = showSearchDlgEN(false);
                        $scope.branchNameChange = branchNameChange;
                        $scope.isHasKongGe = isHasKongGe;
                        //初始化实名认证的国家列表
                        auiTeamAccountService.getRealNameCountryList().then(function (data) {
                            Model.country = data.allContrysFromInterface;
                        });

                        $scope.receiptStatusChange = function (val) {
                            Model.refundInfo.invoiceRefundType = val;
                        };
                        $scope.moneyKeyup = function () {
                            $scope.isMoneyValid = auiBalanceService.validateMoney(Model.refundInfo.money) &&
                                (Model.refundInfo.money <= Model.order.money);
                        };
                        $scope.close = function () {
                            ngdia.close();
                        };
                        $scope.preStep = function () {
                            Model.pageOne = true;
                        };

                        $scope.nextStep = function (isValid, form) {
                            if (!isValid || !Model.isHasKong) {
                                formValidateService.validateForm(form);
                                return;
                            } else {
                                Model.pageOne = false;
                            }

                        };
                        $scope.submitRefund = function (isValid, refundForm2) {
                            if (!isValid) {
                                formValidateService.validateForm(refundForm2);
                                return;
                            } else {
                                //提交生成退款
                                createRefundOrder();
                            }
                        };
                        Model.files = {};
                        // 上传组件
                        Model.uploadAgentAttach = function (files, options, item) {
                            auiUpload.uploadOpenTrade(files, '1', options).then(function (fileUrl) {
                                if (files && files.length > 0) {
                                    Model.files[item + 'Name'] = files[0].name
                                }
                                Model.refundInfo[item] = fileUrl;
                            });

                        };

                        // 正则
                        function isHasKongGe() {
                            Model.isHasKong = /^[^\s]*$/.test(Model.refundInfo.courierNumber);
                            return /^[^\s]*$/.test(Model.refundInfo.courierNumber);
                        }

                        //删除附件
                        $scope.delimg = function (item) {
                            Model.refundInfo[item] = ''
                        };

                        //更新国家
                        function changeCountry(country) {
                            Model.refundInfo.payeeCountry = country;
                        }

                        function changeCountryEn(country) {
                            Model.isHasCountryEn = true;
                            Model.refundInfo.countryEn = country;
                            Model.bankList = [];
                            Model.branchNameList = [];
                            Model.refundInfo.bankNameEn = {};
                            Model.refundInfo.branchName = {};
                            Model.refundInfo.swiftCode = '';
                            Model.isHasCode = true;
                            Model.isHasBank = false;
                            if (Model.refundInfo.countryEn.country == 'CN') {
                                Model.bankType = 1
                            } else {
                                Model.bankType = null
                            }
                            bankSelectService.getBanksEn(Model.bankType, Model.refundInfo.countryEn.country, function (bankList) {
                                Model.bankList = bankList
                            })
                        }

                        function changeBankNameEn(bankNameEn) {
                            Model.isHasBank = true;
                            Model.refundInfo.bankNameEn = bankNameEn;
                            Model.branchNameList = [];
                            Model.refundInfo.branchName = {};
                            bankSelectService.getBankBranchs(Model.refundInfo.bankNameEn.key, null, null, function (branchNameList) {
                                Model.branchNameList = branchNameList
                            }, Model.refundInfo.countryEn.country)
                        }

                        function branchNameChange(branchNam) {
                            Model.refundInfo.branchName = branchNam;
                            if (branchNam.swiftCode) {
                                Model.refundInfo.swiftCode = branchNam.swiftCode;
                                Model.isHasCode = true;
                            } else {
                                Model.isHasCode = false;
                                // 获取规则
                                tenantsService.getBankRuleByCountry(Model.refundInfo.countryEn.country, mainCons.modUserinfoConstant).then(function (merchantCfg) {
                                    //获取规则
                                    Model.selectCountryCfg = merchantCfg.countryBankCfg[Model.refundInfo.countryEn.country];
                                })

                            }
                        }

                        function showSearchDlgEN(isCN) {
                            return function () {
                                bankSelectService.showSearchDlg({
                                    callBack: function (branch) {
                                        Model.refundInfo.swiftCode = branch.swiftCode;
                                        Model.refundInfo.bankNameEn = {
                                            key: branch.bankID,
                                            value: branch.bankName
                                        };
                                        Model.refundInfo.branchName = {
                                            key: branch.branchNumber,
                                            value: branch.branchName,
                                        };
                                    },
                                    initBranchNumber: null,
                                    initswiftCode: Model.refundInfo.swiftCode ? Model.refundInfo.swiftCode : null,
                                    isCN: isCN,
                                    country: Model.refundInfo.countryEn ? Model.refundInfo.countryEn.country : null,
                                    countryName: Model.refundInfo.countryEn ? Model.refundInfo.countryEn.shortName : null
                                });
                            }
                        }

                        function createRefundOrder() {
                            var orderInfo = {
                                purchaseType: Model.order.purchaseType,
                                developer: Model.order.developer,
                                wareId: Model.order.wareId,
                                wareName: Model.order.wareName,
                                money: Model.refundInfo.money ? Model.refundInfo.money : Model.order.money,
                                associateOrderID: Model.order.orderId,
                            };
                            var refundInfo = angular.copy(Model.refundInfo);
                            refundInfo.city = Model.refundInfo.city.value;
                            refundInfo.country = (Model.signParty == 1 || Model.signParty == 4) ? Model.refundInfo.countryEn.value : Model.refundInfo.country.value;
                            refundInfo.province = Model.refundInfo.province.value;
                            refundInfo.refundType = Model.refundInfo.refundType.key;
                            if (Model.refundInfo.agreementFlag == undefined) {
                                refundInfo.agreementFlag = 1;
                            }
                            if (refundInfo.agreementFlag == 1) {
                                refundInfo.agreementAttachments = "";
                            }
                            refundInfo.adSubject = Model.order.developerName || developerInfo.realName;
                            orderInfo.refundType = 1;
                            refundInfo.isSucrefund = Model.isSucrefund;
                            delete refundInfo.money;
                            if ((Model.signParty == 0 && !refundInfo.invoiceRefundType) || ((Model.signParty == 1 || Model.signParty == 4) && Model.order.receiptStatus != 2 && Model.order.receiptStatus != 3)) {
                                refundInfo.invoiceRefundType = 4;
                            } else if ((Model.signParty == 1 || Model.signParty == 4) && (Model.order.receiptStatus == 2 || Model.order.receiptStatus == 3)) {
                                refundInfo.invoiceRefundType = 5;
                            }
                            if (Model.signParty == 1 || Model.signParty == 4) {
                                refundInfo.payeeCountry = Model.refundInfo.payeeCountry.shortName;
                                refundInfo.country = Model.refundInfo.countryEn.shortName;
                                refundInfo.bankName = Model.refundInfo.bankNameEn.key || Model.refundInfo.bankNameEn.value;
                                refundInfo.branchName = Model.refundInfo.branchName.key || Model.refundInfo.branchName.value;
                                delete refundInfo.countryEn;
                                delete refundInfo.bankNameEn;
                                delete refundInfo.province;
                                delete refundInfo.city;
                            } else {
                                delete refundInfo.payeeCountry
                            }
                            var request = {
                                orderInfo: orderInfo,
                                refundInfo: refundInfo,
                            }
                            var defer = $q.defer();
                            OpenTrade.createRefundOrder({req: request}).then(function (data) {
                                if (data && data.retCode == 0) {
                                    ngdia.close();
                                    auiDialog.success("退款申请已提交", function () {
                                        defer.resolve();
                                        init();
                                    });
                                }
                            }).catch(function (data) {
                                if (data == "88820266") {
                                    auiDialog.failSystemError('申请退款金额不能小于门槛金额' + Model.threshold, function () {
                                    });
                                } else if (data == "88820267") {
                                    auiDialog.failSystemError('申请退款金额不能大于充值余额。');
                                } else if (data == "88820026") {
                                    auiDialog.failSystemError('申请退款金额不能大于可用账户余额。');
                                } else {
                                    auiDialog.failSystemError($filter('auiErrorCode')(data), function () {
                                    });
                                }
                                defer.reject();
                            });
                            return defer.promise;
                        }

                        //是否充值成功退款，0：是，1：否
                        function isSucrefundJudge(status, time) {
                            var isSucrefund;
                            if (status == '5' || status == '6' || status == '9') {
                                isSucrefund = 1
                            } else if ((status == '8' || status == '12') && (!time)) {
                                isSucrefund = 1
                            } else {
                                isSucrefund = 0
                            }
                            return isSucrefund
                        }

                        getReceipt();

                        //刷新发票信息
                        function getReceipt() {
                            OpenUp.getReceiptInfo({req: {}}).then(function (data) {
                                if (data && data.resultCode == 0) {
                                    initRefundInfo(data.receipt);
                                    getProviceList();
                                    getCityList(data.receipt.provinceName);

                                }
                            });
                        }

                        //初始化银行相关信息
                        function initRefundInfo(receiptInfo) {
                            if (Model.signParty == 0) {
                                Model.refundInfo.bankAccount = receiptInfo.bankAccount;
                                Model.refundInfo.bankAcctname = receiptInfo.title;
                            }
                            Model.refundInfo.remitter = receiptInfo.title;
                            Model.refundInfo.country = {
                                key: receiptInfo.countryAlpha2Code,
                                value: receiptInfo.country
                            };
                            Model.refundInfo.province = {
                                key: receiptInfo.provinceName,
                                value: receiptInfo.province
                            }
                            Model.refundInfo.city = {
                                key: receiptInfo.cityName,
                                value: receiptInfo.city
                            };
                            Model.refundInfo.bankName = receiptInfo.bankName;
                        }

                        function getProviceList() {
                            regionService.setProvince(function (data) {
                                Model.provinces = data;
                            });
                        }

                        function getCityList(province) {
                            regionService.setCity(province, function (data) {
                                Model.cities = data;
                            });
                        }

                        $scope.changeReceiptInfoProvince = function (province) {
                            Model.refundInfo.city = {
                                key: '',
                                value: ''
                            };
                            getCityList(province);
                        }

                    }]
                });
            }

            //退款详情
            function refundDetail(orderId, signParty, orderMoney) {
                //打开aui申请退款详情
                // auiBalanceService.refundDetail(orderId);
                $state.go('MyAccount.refundDetail', {orderId: orderId, signParty: signParty, orderMoney: orderMoney});
            }

            function queryOrderDetail(orderId, signParty) {
                $state.go('MyAccount.orderDetail', {orderId: orderId, signParty: signParty});
            }

            //申请开票
            function applyBilling(orderId) {
                var ngd = ngDialog.open({
                    template: 'pages/myaccount/balance/order.apply.billing.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scope) {

                        $scope.close = function () {
                            ngd.close();
                        };
                        $scope.applyBilling = function () {
                            var defer = $q.defer();
                            OpenUp.getReceiptInfo({req: {}}).then(function (data) {
                                if (data && data.resultCode == 0) {
                                    var receiptInfo = data.receipt;
                                    var req = {
                                        orderId: orderId,
                                        receipt: receiptInfo
                                    };
                                    OpenTrade.updateOrderReceipt({req: req}).then(function (data) {
                                        ngd.close();
                                        if (data && data.retCode == 0) {
                                            auiDialog.success("申请开票成功。", function () {
                                                defer.resolve();
                                            });
                                        }
                                        //刷新页面
                                        init();
                                    }).catch(function () {
                                        ngd.close();
                                        defer.reject();
                                    });
                                }
                            }).catch(function () {
                                ngd.close();
                                defer.reject();
                            });
                            return defer.promise;
                        };
                        $scope.modReceipt = function () {
                            auiBalanceService.modReceipt($scope);
                        };
                    }]
                });
            }

            //重发发票
            function reapplyBilling(orderId) {
                var defer = $q.defer();
                OpenTrade.sendIAPInvoiceMail({
                    req: {
                        orderId: orderId
                    }
                }).then(function (res) {
                    if (res && res.retCode == 0) {
                        auiDialog.success("重发发票成功。", function () {
                            defer.resolve();
                        });
                    } else {
                        auiDialog.failSystemError();
                        defer.reject();
                    }
                }).catch(function (res) {
                    defer.reject();
                });
                return defer.promise;
            }

            //导出合同
            function exportContract(orderId) {
                var defer = $q.defer();
                OpenTrade.exportPurchaseContract({
                    req: {
                        orderId: orderId
                    }
                }).then(function (res) {
                    if (res && res.downUrl) {
                        auiDialog.download({
                            downloadUrl: res.downUrl,
                            password: res.zipPassword
                        }, function () {
                            defer.resolve();
                        });
                    }
                }).catch(function (data) {
                    defer.reject();
                });
                return defer.promise;
            }


            function init() {

                Model.isSignAgree = true;

                getBalance();
                changeTabType('recharge');
                getDeveloperBaseInfo();
            }

            /* 切换Tab触发的方法 */
            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'recharge':
                        queryList();
                        break;
                    case 'consume':
                        break;
                }
            }

            function getMyDate(mydate) {
                if (mydate) {
                    var year = mydate.substring(0, 4)
                    var month = mydate.substring(4, 6)
                    var day = mydate.substring(6, 8)
                    var hour = mydate.substring(8, 10)
                    var minute = mydate.substring(10, 12)
                    var second = mydate.substring(12, 14)
                    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            }

            // 判断耀星流量券申请转移按钮是否show
            function transferShow(orderDetail) {
                var showFlag = true

                // 1.奖励类型应用市场耀星券的订单。
                if (orderDetail.contractType !== 5 || orderDetail.wareId !== 26) { // 5奖励类型  26应用耀星
                    showFlag = false
                    return showFlag
                }

                // 2.订单创建时间一年以内
                var createTime = orderDetail.createTime
                var timeStamp = new Date(createTime)
                var year = timeStamp.getFullYear()
                var newTime = year + 1 + '' + createTime.substring(4)
                if (Date.parse(new Date(newTime)) < Date.parse(new Date())) {
                    showFlag = false
                    return showFlag
                }

                var validStamp
                // 3 未失效的订单

                var expireDate = Date.parse(new Date(getMyDate(orderDetail.expireDate)))
                var effectiveDate = Date.parse((new Date(getMyDate(orderDetail.effectiveDate))))

                if (expireDate < Date.parse(new Date())) {
                    showFlag = false
                    return showFlag
                }

                if (effectiveDate > Date.parse(new Date())) {
                    showFlag = false
                    return showFlag
                }


                var orderStatus = [2, 19]
                // 只有交易成功，失效审批失败状态支持转移申请
                if (orderStatus.indexOf(orderDetail.status) === -1) { // 2交易成功 17 18审核中  19失败 20成功
                    showFlag = false
                    return showFlag
                }

                return showFlag
            }

            // 申请转移事件
            function appTransfer(order) {
                OpenTrade.checkOrderConsumeStatus({
                    req: {
                        serviceName: 'HuaweiDeveloper',
                        orderID: order.orderId
                    }
                }).then(function (res) {
                    if (res.checkResult === 0) {
                        $state.go('MyAccount.flowTransfer', {orderId: order.orderId})
                    } else {
                        auiDialog.failSystemError('该订单已被消耗，暂不支持失效转移', function () {

                        });
                    }

                }).catch(function (data) {
                    var msg = $filter('auiErrorCode')(data.NSP_STATUS, data.serviceName);
                    auiDialog.failSystemError(msg, function () {
                    });
                })
            }

            // 详情按钮
            function transferDetail(order) {
                var transFerShow = true;
                var myStatus = [19]
                if (myStatus.indexOf(order.status) === -1) {
                    transFerShow = false
                    return transFerShow
                }
                return transFerShow
            }

            // 详情事件
            function appTransferDetail(order) {
                OpenTrade.getInvalidOrderDetail({
                    req: {
                        serviceName: 'HuaweiDeveloper',
                        orderID: order.orderId
                    }
                }).then(function (res) {
                    if (res && res.orderTransferInfo) {
                        auiDialog.fail('失效失败', res.orderTransferInfo.approveExternalDesc);
                    } else {
                        auiDialog.fail('失效失败');
                    }
                }).catch(function (data) {

                })

            }

        }]);
});

